import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"money"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21.5002 11V21H2.5002L2.5002 11L21.5002 11Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M11.9996 13.5C13.3803 13.5 14.4996 14.6193 14.4996 16C14.4996 17.3807 13.3803 18.5 11.9996 18.5C10.6189 18.5 9.49961 17.3807 9.49961 16C9.49961 14.6193 10.6189 13.5 11.9996 13.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M17.1357 6.29148L19.0003 5.66995L20.8239 11.0033H3.0021L2.99902 11.0043L14.1461 2.09998L17.1357 6.29148Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 11.0033H20.8243L19.0007 5.66992L3.35369 11.0033L3 10.9999M2.5 11.0043H2.99942L14.1465 2.09998L16.9636 6.04956","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14.5 16C14.5 17.3807 13.3807 18.5 12 18.5C10.6193 18.5 9.5 17.3807 9.5 16C9.5 14.6193 10.6193 13.5 12 13.5C13.3807 13.5 14.5 14.6193 14.5 16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21.5002 11V21H2.5002L2.5002 11L21.5002 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M2.5 11L4.5 11C4.5 12.1046 3.60457 13 2.5 13L2.5 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21.5005 11H19.5C19.5 12.1048 20.3956 13.0005 21.5005 13.0005V11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M2.5 21H4.50195C4.50195 19.8944 3.60565 18.998 2.5 18.998L2.5 21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21.5 21H19.5C19.5 19.8954 20.3954 19 21.5 19V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Money = Vue.extend<IconProps>({
  name: 'MoneyIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'money',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Money;
